import { chatAppbarCallbackManager } from './chat-app-bar'

function setAppbarHeightCSSVar(height: number) {
  document.documentElement?.style.setProperty(
    '--view-app-bar-height',
    `${height}px`,
  )
}

export let chatAppbarIsExpandedDefaultValue = true
interface ChatAppbarProps {
  expanded: boolean
  height: number
}

export const AppbarApi = {
  setAppbarHeight({ expanded, height }: ChatAppbarProps) {
    setAppbarHeightCSSVar(height)
    chatAppbarCallbackManager.runCallbacks(expanded)
    chatAppbarIsExpandedDefaultValue = expanded
  },
}
